import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlagCheckered } from "@fortawesome/free-solid-svg-icons";
import { PageNavContext } from "../FunctionalPageLoginStart";
import './RightElements.css';

const DailyGoalsCard = ({ exercisesDone = 1, exercisesTotal = 4, challengesDone = 0, challengesTotal = 3, xpDone = 0, xpTotal = 95 }) => {
  const onPageNav = useContext(PageNavContext);

  const missions = [
    { text: 'Castiga 300 XP', progress: xpDone, total: xpTotal },
    { text: 'Completeaza 3 lectii', progress: challengesDone, total: challengesTotal },
    { text: 'Rezolva 5 aplicatii', progress: exercisesDone, total: exercisesTotal },
  ];

  const handleOpenMissions = (event) => {
    event.preventDefault();
    if (onPageNav) {
      onPageNav('Misiuni');
    }
  };

  return (
    <div className="rightmenu-card dailygoals-card">
      <div className="section daily-goals">
        <span className="get-pro-title">Misiuni zilnice</span>
        <a href="#" className="section-link" onClick={handleOpenMissions}>Acceseaza</a>
        <div className="daily-missions-list">
          {missions.map((mission, index) => {
            const percent = Math.round((mission.progress / mission.total) * 100);
            const isCompleted = percent === 100;

            return (
              <div
                key={index}
                className={`daily-mission-item ${isCompleted ? 'daily-mission-completed' : ''}`}
              >
                <div className="daily-mission-header">
                  <div className="daily-mission-text">{mission.text}</div>

                  <div className="daily-mission-right">
                    <span className="daily-mission-percent">{percent}%</span>
                    <FontAwesomeIcon
                      icon={faFlagCheckered}
                      className="daily-mission-flag"
                    />
                  </div>
                </div>

                <div className="daily-mission-progress-bar">
                  <div
                    className="daily-mission-progress-fill"
                    style={{ width: `${percent}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DailyGoalsCard;
